module.exports = __webpack_public_path__ + "static/amulet_of_health-2b88260214955c6bae1180fa98d60a5b.jpeg";